export default {
  cart: state => state.cart,
  cartItems: state => state.cartItems,
};
